import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import lightbulbFilamentIcon from "@phosphor-icons/core/regular/lightbulb-filament.svg";

const ChatOnlyTool = lazy(() => import("../renderers/chat-only-tool.tsx"));

export const recommendAssignments: Tool = {
    urlSlug: "recommend-assignments",
    configName: "activity-assignment-recommendations",
    title: () => t`Recommend assignments`,
    description: () =>
        t`Receive recommendations on what your students should work on next`,
    categories: [
        ToolCategories.Plan,
        ToolCategories.Learn,
        ToolCategories.Differentiate,
    ],
    icon: lightbulbFilamentIcon,
    color: color.fadedPurple24,
    layout: Layout.ChatOnly,
    activitySlug: "activity-assignment-recommendations",
    reportingLabelId: "assignment-recommendations",
    requestedInputs: [
        {
            inputKind: "CLASSROOM_SELECT",
            label: () => t`Classroom`,
            description: () => t`Select the class you want to review.`,
            variableName: "classroomDescriptor",
            required: true,
        },
    ],
    component: ({configName}) => <ChatOnlyTool configName={configName} />,
};
